import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DexieService } from './dexieService';
import { OnlineService } from './online.service';
import { Observable, from, map } from 'rxjs';
import { HttpUtils } from '../utils/httpUtils';
import { ExecutionQTestDataOQ } from '../model/execution';

@Injectable({
    providedIn: 'root'
})

export class ExecutionQTestDataOQService {
    protected readonly url = `${environment.qualificatesUrl}/executionQTestDataOQ`;

    constructor(private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) { }

    findByExecutionTestId(id: number): Observable<any>{
        if (this.onlineService.latestOnline) {
            return this.http.get(`${this.url}/test/${id}`).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.roomType.toArray().timeout(30000));
        }
    }

     updateDataOQ(idExecutionTest: number, data: ExecutionQTestDataOQ): Observable<any> {
        const url = `${this.url}/${idExecutionTest}`;
        return this.http.put(url, data).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
      }

}
